import { createSlice } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api";

export const initialState = {
  vendorSubUsers: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
};

export const vendorSubUserSlice = createSlice({
  name: 'vendorSubUser',
  initialState: initialState,
  reducers: {
    setVendorSubUser: (state, { payload }) => {
    state.vendorSubUsers = payload?.data ?? payload;
    state.total = payload?.total;
    state.is_more = payload?.is_more;
    state.last_page = payload?.last_page;
    state.current_page = payload?.current_page;
    state.per_page = payload?.per_page;
  },
  setVendorSubUsers: (state, { payload }) => {
    state.vendorSubUsers = payload?.data;
    state.total = payload?.total;
    state.is_more = payload?.is_more;
    state.last_page = payload?.last_page;
    state.current_page = payload?.current_page;
    state.per_page = payload?.per_page;
  },
  setMoreVendorSubUsers: (state, { payload }) => {
    state.vendorSubUsers = state.vendorSubUsers.concat(payload.data);
    state.total = payload.total;
    state.is_more = payload.is_more;
    state.last_page = payload?.last_page;
    state.current_page = payload?.current_page;
    state.per_page = payload?.per_page;
  },
    removeVendorSubUser: (state, { payload }) => {
      state.error = payload;
    },
    clearAllVendorSubUser: (state, { payload }) => {
      state.loader = payload;
    },
    setVendorError: (state, { payload }) => {
      state.error = payload;
    },
    setVendorLoader: (state, { payload }) => {
      state.loader = payload;
    },
  },
});

// ✅ ADD VENDOR SUB USER
export const addVendorSubUsers = (data, callback) => async (dispatch) => {
  dispatch(setVendorError({}));
  dispatch(setVendorLoader(true));
  try {
    const json = await Api.addVendorSubUsers(data);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setVendorError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setVendorLoader(false));
};

// ✅ UPDATE VENDOR SUB USER
export const updateVendorSubUsers = (data, itemId, callback) => async (dispatch) => {
  dispatch(setVendorError({}));
  dispatch(setVendorLoader(true));
  try {
    const json = await Api.updateVendorSubUsers(data, itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setVendorError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setVendorLoader(false));
};

// ✅ REMOVE SINGLE VENDOR SUB USER
export const removeVendorSubUsers = (itemId, callback) => async (dispatch) => {
  dispatch(setVendorError({}));
  dispatch(setVendorLoader(true));
  try {
    const json = await Api.removeVendorSubUsers(itemId);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setVendorError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setVendorLoader(false));
};

// ✅ FETCH ALL VENDOR SUB USERS
export const fetchVendorSubUsers = (page, params, disableLoader) => async (dispatch) => {
  !disableLoader && dispatch(setVendorLoader(true));
  try {
    const result = await Api.fetchVendorSubUsers(page, params);
    if (result.status >= 200 && result.status < 300) {
      dispatch(setVendorSubUsers(result.data.data));
      console.log("DEBUG result.data:", result.data);
    } else if (result?.status === 422) {
      dispatch(setVendorError(result.data));
    }
  } catch (error) {
    console.log("error", error);
  }
  !disableLoader && dispatch(setVendorLoader(false));
};

// ✅ CHANGE STATUS
export const changeVendorStatus = (id, data) => async (dispatch) => {
  dispatch(setVendorError({}));
  dispatch(setVendorLoader(true));
  try {
    const json = await Api.statusChange(id, data, "vendor-sub-users");
    if (json.status === 422) {
      dispatch(setVendorError(json.data));
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setVendorLoader(false));
};

// ✅ REMOVE MULTIPLE VENDOR SUB USERS
export const removeMultipleVendorSubUsers = (ids, callback) => async (dispatch) => {
  dispatch(setVendorError({}));
  dispatch(setVendorLoader(true));
  try {
    const json = await Api.removeMultipleVendorSubUsers(ids);
    if (json.status >= 200 && json.status < 300) {
      callback(true, json.data.message);
    } else if (json.status === 422) {
      dispatch(setVendorError(json.data));
      callback(false, json.data.message);
    }
  } catch (error) {
    console.log(error);
  }
  dispatch(setVendorLoader(false));
};

// ✅ Export Actions
export const {
  setVendorSubUser,
  setVendorSubUsers,
  clearAllVendorSubUser,
  setVendorLoader,
  setVendorError,
  setMoreVendorSubUsers,
} = vendorSubUserSlice.actions;

// ✅ Aliases for component imports
export const setVendorSubUserError = setVendorError;
export const addVendorSubUser = addVendorSubUsers;
export const updateVendorSubUser = updateVendorSubUsers;
export const changeVendorSubUserStatus = changeVendorStatus;

// ✅ Export Reducer
export default vendorSubUserSlice.reducer;

// ✅ Selector
export const vendorSubUserSelector = (state) => state.vendorSubUser;
